import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { scrollToElement } from "../../../helpers";
import FormikContactMeForm from "./components/FormikConactMeForm";
import FadeInOut from "./components/FadeInOut";

const Home: React.FC = () => {
  const [message, setMessage] = useState<{ id: string; value: string }>();
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.hash.substring(1);
    if (sectionId !== "") {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element != null) {
          window.scrollTo(0, element.offsetTop);
        }
      }, 200);
    }
  }, [location.hash]);

  return (
    <React.Fragment>
      <main role="main" className="container-fluid px-0 main">
        {/* primary head */}
        <FadeInOut show={true} duration={500} className={"box"}>
          <header className="masthead" id={"pageTop"}>
            <div className="container">
              <div className="col-md-7">
                <div className="masthead-subheading intro-text">
                  <div className="masthead-heading text-uppercase mb-2">
                    Front-end, Back-end & Mobile Developer
                  </div>
                  <div className="intro-heading">
                    Programming is my passion, and my passion is my profession.
                  </div>
                  <Link
                    to=""
                    className="btn btn-primary btn-xl text-uppercase mt-4"
                    onClick={() => {
                      scrollToElement("services");
                    }}
                  >
                    Read More!
                  </Link>
                </div>
              </div>
            </div>
          </header>
        </FadeInOut>

        {/* Expertise */}
        <FadeInOut show={true} duration={500} className={"box"}>
          <section id="services" className="page-section">
            <div className="container">
              <div className="text-center">
                <h2 className="section-heading text-capitalize">Expertise</h2>
                <h3 className="section-subheading text-muted">
                  Thanks you for taking the time to visit.
                </h3>
                <h3 className="section-subheading text-muted">
                  As an experienced Application Developer and ICT Consultant, I
                  possess a proven track record of excellence in web and mobile
                  application development, backend API creation, and application
                  optimisation.
                  <Link
                    to="/#services"
                    onClick={() => window.open("mailto:info@webcodre.com")}
                    className="text-primary font-weight-bold"
                  >
                    Lets make a difference.
                  </Link>
                </h3>
                <p className="text-muted">
                  Git, Docker, Ubuntu, PHPStorm, VsCode are used in almost every
                  project.
                </p>
              </div>
              <div className="row text-center justify-content-between">
                <div className="col border-primary border m-2">
                  <div className="card mt-2 p-2 border-0">
                    <div className="text-center">
                      <span className="fa-stack fa-4x">
                        <i className="fa fa-circle fa-stack-2x text-primary" />
                        <i className="fa fa-css3 fa-stack-1x fa-inverse" />
                      </span>
                    </div>
                    <div className="card-body d-inline-block d-flex flex-column justify-content-between">
                      <h5 className="card-title">Front-end Developer</h5>
                      <p className="card-text">
                        I enjoy fixing bugs, code from scratch, and enjoy
                        bringing ideas to life in existing applications.
                      </p>
                      <p className="text-primary font-weight-bold">
                        language I can speak:
                      </p>
                      <p className="text-muted">
                        HTML5, CSS, Javascript, JQuery, Vue, React, Bootstrap,
                        Tailwind, Redux, Vuex
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col border-primary border m-2">
                  <div className="card mt-2 p-2 border-0">
                    <div className="text-center">
                      <span className="fa-stack fa-4x text-center">
                        <i className="fa fa-circle fa-stack-2x text-primary" />
                        <i className="fa fa-code fa-stack-1x fa-inverse" />
                      </span>
                    </div>
                    <div className="card-body d-flex flex-column justify-content-between">
                      <h5 className="card-title">Back-end Developer</h5>
                      <p className="card-text">
                        I value simple but structured coding style, and always
                        follow best and secure coding practices.
                      </p>
                      <p className="text-primary font-weight-bold">
                        Experiences I draw from
                      </p>
                      <p className="text-muted">
                        PHP, Node js, Express js, Laravel 4 - 7
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col border-primary border m-2">
                  <div className="card mt-2 p-2 border-0">
                    <div className="text-center">
                      <span className="fa-stack fa-4x text-center">
                        <i className="fa fa-circle fa-stack-2x text-primary" />
                        <i className="fa fa-mobile fa-stack-1x fa-inverse" />
                      </span>
                    </div>
                    <div className="card-body d-flex flex-column justify-content-between">
                      <h5 className="card-title">Mobile App Developer</h5>
                      <p className="card-text">
                        Mobile app development is one of my hobby. I like to
                        create mobile apps for fun and professionally.
                      </p>
                      <p className="text-primary font-weight-bold">
                        Currently i am using:
                      </p>
                      <p className="text-muted">
                        React Native, Redux, React-router, Expo
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </FadeInOut>

        {/* Clients */}
        <section className="page-section bg-white" id="clients">
          <div className="container">
            <div className="text-center">
              <h2 className="section-heading text-capitalize">References</h2>
              <h3 className="section-subheading text-muted">
                I&#39;m proud to be a part of some awesome companies:
              </h3>
            </div>
            <div className="row">
              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://www.mazhr.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="data:image/png;base64,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"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>
              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://fressi.fi"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="/assets/img/clients/Fressi-logo-x-290-retina.png"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>
              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://www.colart.com/en/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-h-50"
                      src="/assets/img/clients/cropped-logo.png"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>
              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://loop4.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"fa"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="/assets/img/clients/loop4.png"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>
              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://coinmotion.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="/assets/img/clients/coinmotion.svg"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>

              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://linecut.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="/assets/img/clients/linecut-logo.svg"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>

              <div className="col-md-3 col-sm-6 my-3 d-flex justify-content-center align-items-center">
                <a
                  href="https://valays.fi/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <FadeInOut show={true} duration={500} className={"box"}>
                    <img
                      className="img-fluid d-block mx-auto w-210"
                      src="/assets/img/clients/valays.png"
                      alt=""
                    />
                  </FadeInOut>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Contact me modal */}
        <div
          className="portfolio-modal modal fade pr-0"
          id="contactMe"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="close-modal">
                <Link
                  className="nav-link text-primary pr-3 pl-3"
                  to={"/"}
                  onClick={() => {
                    setMessage(undefined);
                  }}
                >
                  <i className="fa fa-times fa-2x" />
                </Link>
              </div>
              <div className="container mt-3 pr-3 pl-3">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    <div className={"modal-body"}>
                      <div className={"container"}>
                        <div className="text-center">
                          <h2 className="section-heading">
                            Let&#39;s make a difference
                          </h2>
                        </div>
                        <div className="row">
                          <div className="col-md-12 my-5 text-left">
                            {message !== null ? (
                              <div
                                className={
                                  message?.id === "EMAIL_SENT"
                                    ? "alert alert-success w-100"
                                    : "alert alert-danger w-100"
                                }
                              >
                                {message?.id === "EMAIL_SENT" ? (
                                  <strong>Success! </strong>
                                ) : (
                                  <strong>Error! </strong>
                                )}
                                {message?.value}
                              </div>
                            ) : null}
                            <FormikContactMeForm
                              sendEmail={() => {
                                console.log("send email");
                              }}
                              setMessage={setMessage}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </React.Fragment>
  );
};
export default Home;
